<template>
    <v-autocomplete
        v-model="childData"
        :items="cities"
        :label="label"
        :rules="rules"
        :disabled="disabled"
        item-text="name"
        clearable
    ></v-autocomplete>
</template>
<script>
import citydata from '@/services/citiesdata.json';
export default {
    name: "city-autocomplete",
    props:{
        value: Object, //因為要跟父元件的v-model綁定，屬性名稱必須叫做value。
        label: String, //對應到Label
        rules: Array, //對應到Rule
        disabled: Boolean, 
    },
    data(){
        return {
            childData: this.value,
            items:[],
        }
    },
    created(){
        this.items = citydata
    },
    computed:{
        cities(){
            return this.items;
        }
    },
    watch:{
        value(val){
            //把父元件送來的資料，轉成Model後送給子元件綁定值
            this.childData = val
        },
        childData(val,prev){
            //如果prev是文字，且val.name = prev , 就不用$emit
            if ((typeof(prev) ==='string') && (prev === val.name)) return
            //把子元件的值，回傳父元件的input函式
            //this.$emit('input', this.getModel(val))
            this.$emit('changeVal', this.getModel(val))
        }
    },
    methods:{
        getModel(val){
            if (val === null) return val
            var itemName = (typeof(val) === 'string') ? val: val.name
            //以下的寫法，用來尋找陣列中符合條件的元素索引值，再利用索引值結果，回傳適合的結果
            let filter = (element) => element.name === itemName
            let idx = this.items.findIndex(filter)
            return (idx >= 0) ? this.items[idx] : val
        }
    }
}
</script>